import { render, staticRenderFns } from "./TgCjAcg.vue?vue&type=template&id=50495724&"
import script from "./TgCjAcg.vue?vue&type=script&lang=js&"
export * from "./TgCjAcg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports